import { RESOURCE_ICONS, RESOURCE_NAMES, RESOURCE_TEXT } from '../../icons';
import { formatNumber } from '../../labels';

type CostKey = 'metal' | 'gas' | 'supplies' | 'credits';
const ORDER: CostKey[] = ['metal', 'gas', 'supplies', 'credits'];

/** A cost; entries the system cannot pay from what it stores are shown in red. */
export function CostList({
  cost,
  available,
}: {
  cost: Partial<Record<CostKey, number>>;
  available?: Partial<Record<CostKey, number>>;
}) {
  const entries = ORDER.filter((key) => (cost[key] ?? 0) > 0);
  return (
    <ul className="flex flex-wrap gap-x-3 gap-y-0.5 font-mono text-xs tabular-nums">
      {entries.map((key) => {
        const Icon = RESOURCE_ICONS[key];
        const short = available?.[key] !== undefined && (available[key] ?? 0) < (cost[key] ?? 0);
        return (
          <li
            key={key}
            data-cost={key}
            data-short={short ? 'true' : 'false'}
            title={`${RESOURCE_NAMES[key]}${short ? ' — not enough stored' : ''}`}
            className={`flex items-center gap-1 ${short ? 'text-danger' : 'text-muted'}`}
          >
            <Icon className={`size-3.5 ${short ? '' : RESOURCE_TEXT[key]}`} aria-hidden />
            {formatNumber(cost[key] ?? 0)}
            <span className="sr-only"> {RESOURCE_NAMES[key]}</span>
          </li>
        );
      })}
    </ul>
  );
}
